export default __webpack_public_path__ + "static/Segment-738d4ce449daab196b9d025aa2569caf.png";